// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".references[data-v-f299f14a]{padding:1rem}.photo-gallery[data-v-f299f14a]{padding:2em 1em 1em}.navbar-item.is-active[data-v-f299f14a]{background-color:#e4e8f7}.references a.navbar-item[data-v-f299f14a]:first-letter{text-transform:capitalize}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
